const generateComponentTheme = (theme) => {
  const { colors } = theme

  const componentVariables = {
    background: colors?.backgroundBrandSecondary
  }

  return componentVariables
}
export default generateComponentTheme